export interface SummaryCard {
  label: string;
  value: string;
  note: string;
  tone: "default" | "danger" | "highlight";
}

export const reportSummary: SummaryCard[] = [
  { label: "إجمالي المبيعات", value: "12,450 ر.س", note: "↑ 15%", tone: "default" },
  { label: "العمولة", value: "1,867 ر.س", note: "15% من المبيعات", tone: "default" },
  { label: "الغرامات", value: "75 ر.س", note: "غرامة واحدة", tone: "danger" },
  { label: "صافي المستحق", value: "10,508 ر.س", note: "بعد الخصومات", tone: "highlight" },
];

export interface DailyRevenue {
  day: string;
  amount: number;
}

export const dailyRevenue: DailyRevenue[] = [
  { day: "11 أغسطس", amount: 980 },
  { day: "12 أغسطس", amount: 1240 },
  { day: "13 أغسطس", amount: 1100 },
  { day: "14 أغسطس", amount: 1450 },
  { day: "15 أغسطس", amount: 890 },
  { day: "16 أغسطس", amount: 1320 },
  { day: "17 أغسطس", amount: 1560 },
];

export interface DayOrders {
  day: string;
  completed: number;
  cancelled: number;
}

export const dailyOrders: DayOrders[] = [
  { day: "11 أغسطس", completed: 18, cancelled: 2 },
  { day: "12 أغسطس", completed: 22, cancelled: 1 },
  { day: "13 أغسطس", completed: 20, cancelled: 3 },
  { day: "14 أغسطس", completed: 25, cancelled: 1 },
  { day: "15 أغسطس", completed: 16, cancelled: 2 },
  { day: "16 أغسطس", completed: 24, cancelled: 2 },
  { day: "17 أغسطس", completed: 21, cancelled: 1 },
];

export const orderStats = {
  total: 147,
  completed: 128,
  completedPct: 87,
  cancelled: 12,
  cancelledPct: 8,
  rejected: 7,
  rejectedPct: 5,
  avgValue: "85 ر.س",
  topService: "غسل خارجي وداخلي",
};

export interface ReportOrder {
  id: string;
  date: string;
  service: string;
  amount: string;
  commission: string;
  net: string;
}

export const reportOrders: ReportOrder[] = [
  { id: "GH-2845", date: "16 أغسطس", service: "غسل خارجي وداخلي", amount: "70", commission: "10.50", net: "59.50" },
  { id: "GH-2844", date: "16 أغسطس", service: "مغاسل ملابس", amount: "160", commission: "24", net: "136" },
  { id: "GH-2843", date: "15 أغسطس", service: "غسل خارجي", amount: "35", commission: "5.25", net: "29.75" },
  { id: "GH-2841", date: "15 أغسطس", service: "تنظيف شامل", amount: "340", commission: "51", net: "289" },
  { id: "GH-2839", date: "14 أغسطس", service: "مغاسل ملابس", amount: "60", commission: "9", net: "51" },
  { id: "GH-2836", date: "14 أغسطس", service: "تنظيف شامل", amount: "285", commission: "42.75", net: "242.25" },
  { id: "GH-2833", date: "13 أغسطس", service: "تلميع كامل", amount: "150", commission: "22.50", net: "127.50" },
  { id: "GH-2831", date: "13 أغسطس", service: "غسل خارجي وداخلي", amount: "70", commission: "10.50", net: "59.50" },
];